<template>
	<div>
		<div class='sl' v-show='vw <=1024'>
			<div class="padding">
				<div class="owl-carousel">
					<!-- <pre>{{items}}</pre> -->
					<template v-for='item in items'>
						<div class="item">
							<div class="hdr">{{item.header}}</div>
							<div class="text">{{item.text}}</div>
						</div>
					</template>
				</div>
			</div>
			
			<div class="row">
				<div class="cols s_24">
					<div class="progress">
						<div class="pointer" :style='`width: ${pointerWidth}px; transform: translateX(${left}px)`'></div>
					</div>
				</div>
			</div>
		</div>
		
		<div class='sc' v-show='vw > 1024'>
			<ul class="grid l_2">
				<li v-for='item in items'>
					<div class="hdr">{{item.header}}</div>
					<div class="text">{{item.text}}</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
module.exports = {

	props: ['data'],

	data () {
		return {
			pointerWidth: 0,
			progressBarWidth: 0,
			left: 0,
			vw: $(window).width()
		}
	},
	
	computed: {
		items() {
			return this.data.items || {};
		},
		count() {
			if(this.vw < 640) {
				return this.items.length
			}
			if(640 <= this.vw && this.vw < 1024) {
				return Math.floor(this.items.length / 2)
			}
			if(1024 <= this.vw && this.vw < 1180) {
				return Math.floor(this.items.length / 3)
			}
		}
	},
	
	mounted() {
		// slider progress bar logic
		this.progressBarWidth = $(this.$el.querySelector('.progress')).width();
		
		$(window).resize(() => {
			this.vw = $(window).width();
			this.progressBarWidth = $(this.$el.querySelector('.progress')).width();
			this.pointerWidth = (this.progressBarWidth - 4) / this.count;
		})
		
		
		// when big video block is ready, run scrollmagic logic
		let controller = false;

		$('#body').on('video-is-done', () => {
			if(window.innerWidth < 1180) {
				// console.log('mobile');
				if(controller) {
					controller.destroy(true);
					controller = false;
				}
			}
			else {
				// console.log('desktop');
				if(!controller) {
					controller = new ScrollMagic.Controller();
					
					var scene = new ScrollMagic.Scene({
						triggerElement: '#pin1', 
						duration: $('.Bx24-complex .for-slider').height() * 2,
						triggerHook: .1
					});
					
					scene.setPin("#pin1");
					// scene.addIndicators({name: `1 (duration: ${$('.for-slider .sc ul').height()})`});
					
					scene.on('progress', e => {
						$('.Bx24-complex .for-slider').scrollTop($('.for-slider .sc ul').height() * e.progress);
						
						if(e.progress > 0) {
							$('.Bx24-complex .for-video .scroll-progress .step.one').addClass('active');
						}
						else {
							$('.Bx24-complex .for-video .scroll-progress .step.one').removeClass('active');
						}
						
						if(e.progress > 0.4) {
							$('.Bx24-complex .for-video .scroll-progress .step.two').addClass('active');
						}
						else {
							$('.Bx24-complex .for-video .scroll-progress .step.two').removeClass('active');
						}
						
						if(e.progress > .8) {
							$('.Bx24-complex .for-video .scroll-progress .step.three').addClass('active');
						}
						else {
							$('.Bx24-complex .for-video .scroll-progress .step.three').removeClass('active');
						}
					});
					
					scene.addTo(controller);
				}
			}
		});
		
		// $('#body').trigger('video-is-done');
	},

	updated() {
		this.progressBarWidth = $(this.$el.querySelector('.progress')).width();
		this.vw = $(window).width();
		this.progressBarWidth = $(this.$el.querySelector('.progress')).width();
		this.pointerWidth = (this.progressBarWidth - 4) / this.count;
		
		this.$emit('updated', {
			owlSettings: {
				margin: 30,
				nav: true,
				loop: this.items.length > 1 ? true : false,
				responsive: {
					0: {
						items: 1,
						// stagePadding: 55
					},
					480: {
						items: 1,
						// stagePadding: 120
					},
					640: {
						items: 2,
						// stagePadding: 50
					},
					768: {
						items: 2,
						// stagePadding: 100
					},
					1024: {
						items: 3,
						// stagePadding: 75
					}
				},
				onTranslated: (e) => {
					this.left = this.pointerWidth * e.page.index;
				}
			}
		});
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.global-slider-container {
	.slider-bx24-complex {
		overflow: hidden;
		touch-action: manipulation;
		
		.sl {
			
			.padding {
				@include m__up {
					padding: 0 rem(80);
					position: relative;
				};
			}
	
			.owl-carousel {
				margin: 0 0 rem(20);
	
				.item {
					color: #303339;
					border: 2px solid #F4F5F5;
					padding: rem(12) rem(28) 2px;
					height: rem(170);
					@include m__up {
						height: rem(150);
					};
					
					.hdr {
						font-size: rem(20);
						line-height: rem(24);
						height: rem(60);
						// background-color: rgba(red, .1);
						display: flex;
						align-items: center;
					}
					
					.text {
						font-family: $Circe_light;
						line-height: rem(22);
						// background-color: rgba(blue, .1);
						height: rem(70);
						overflow: hidden;
					}
				}
				
				.owl-nav {
					display: flex;
					justify-content: space-between;
					padding: rem(20) 0 0;
					@include m__up {
						display: block;
					};
					
					.owl-prev, .owl-next {
						height: rem(62);
						border: rem(2) solid #D4DFE6;
						width: rem(130);
						border-radius: rem(30);
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: 0;
						@include single-transition;						
						@include m__up {
							width: rem(50);
							height: rem(62);
							position: absolute;
							top: calc(50% - #{rem(62) / 2})
						};
						
						&:after {
							content: '';
							display: block;
							width: rem(8);
							height: rem(13);
							background-color: red;
							opacity: .5;
							@include single-transition;
						}
						
						&:hover {
							background-color: #D4DFE6;
							
							&:after {
								opacity: 1;
							}
						}
					}
					
					.owl-next {
						@include m__up {
							right: 0;
						};
						
						&:after {
							background: url('#{$imgPathSCSS}bx24-slider-arrow.png') no-repeat center;
						}
					}
					
					.owl-prev {
						@include m__up {
							left: 0;
						};
						
						&:after {
							background: url('#{$imgPathSCSS}bx24-slider-arrow.png') no-repeat center;
							transform: rotate(180deg);
						}
					}
				}
			}
			
			.progress {
				height: rem(8);
				background-color: #F4F5F5;
				// background-color: red;
				position: relative;
				border-radius: rem(4);
				margin-bottom: rem(45);
				// @media (max-width: 689px) {
				// 	margin-left: rem(15);
				// 	margin-right: rem(15);
				// }
				// @media (min-width: 690px) and (max-width: 1179px) {
				// 	margin-left: calc((100vw - 690px) / 2);
				// 	margin-right: calc((100vw - 690px) / 2)
				// }
				@include m__up {
					margin-bottom: rem(30);
				};
				
				.pointer {
					height: rem(4);
					border-radius: rem(2);
					background-color: #CECFD0;
					// background-color: blue;
					position: absolute;
					top: rem(2);
					left: 2px;
					z-index: 1;
					@include single-transition;
				}
			}
		}
		
		.sc {
			
			ul {
				
				li {
					color: #303339;
					border: 2px solid #F4F5F5;
					padding: rem(12) rem(28) 2px;
					height: rem(145);
					&:last-child {
						margin-bottom: 0;
					}
					&:nth-last-child(2) {
						margin-bottom: 0;
					}
					
					.hdr {
						font-size: rem(20);
						line-height: rem(24);
						height: rem(55);
						// background-color: rgba(red, .1);
						display: flex;
						align-items: center;
						@include l___up {
							font-size: rem(24);
						};
					}
					
					.text {
						font-family: $Circe_light;
						line-height: rem(22);
						// background-color: rgba(blue, .1);
						height: rem(70);
						overflow: hidden;
						@include l___up {
							font-size: rem(18);
						};
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// bx24-complex.vue?4e39662b